import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { getCookie } from "../shared/helpers";

export const LoginRoute = (props) => {
    return props.auth !=null || getCookie("token")!=null ? (
      <Route {...props} />
    ) : (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: props.location },
        }}
      />
    );
  };